/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum CommerceTransactionsWorkspaceCapabilityUdoTemplateKey {
    coupon = "7b20f584-5d1f-4239-bf7a-e67a4d5d0a0f",
    cart = "b64095fe-094b-49f5-8c00-c1e79224d630",
    cartItem = "741fd5d0-47f7-47df-aa3f-8f18ba385858",
    order = "2780c179-e93c-42c4-9059-3a2009759ecc",
    orderItem = "3303f005-f72d-4080-a150-bb9364bd06d0",
    invoice = "3f867d1e-68aa-4c15-bac8-5f3ba649723d",
}
